/**
 * ChipArray.tsx
 * Disability Insurance Services
 *
 * Created by Jeremy Moyers
 */

import MuiChip from "@mui/material/Chip";
import { withStyles } from "@mui/styles";
import React from "react";
import { Field } from "react-final-form";
import { FieldArray } from "react-final-form-arrays";

interface IChipArrayProps {
  name: string;
  chipStyles?: any;
  itemRenderer?: (props: any) => React.ReactNode;
}

const Chip = withStyles(theme => ({
  root: {
    margin: "4px",
    color: "black",
    border: "none",
    userSelect: "unset !important" as any,
    backgroundColor: "white",
  },
  deleteIcon: {
    fontSize: "14px",
    color: "black",
  },
}))(MuiChip);

export default class ChipArray extends React.Component<IChipArrayProps> {
  render() {
    const { name, chipStyles, itemRenderer } = this.props;
    return (
      <FieldArray name={name}>
        {({ fields }) => (
          <div>
            {fields.map((name, index) => {
              return (
                <Field key={`${index}`} name={name}>
                  {({ input, meta }) => (
                    <Chip
                      key={`${index}`}
                      label={itemRenderer ? itemRenderer(input.value) : input.value}
                      style={chipStyles || { backgroundColor: "white", color: "black" }}
                      onDelete={event => {
                        event.preventDefault();
                        fields.remove(index);
                      }}
                    />
                  )}
                </Field>
              );
            })}
          </div>
        )}
      </FieldArray>
    );
  }
}
